import { Theme } from "@mui/material/styles";
import { makeStyles, createStyles } from "@mui/styles";

export const guideModalStyles = makeStyles((theme: Theme) =>
  createStyles({
    sucessIcon: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
    },
    content: {
      textAlign: "center",
    },
    contentText: {
      textAlign: "center",
      marginBottom: 20,
    },
    successMsg: {
      textAlign: "center",
      color: "#5DB661",
      font: "28px",
      fontWeight: "bold",
    },
    getAccessPopup: {
      marginTop: 10,
      textAlign: "center",
    },
    closeButton: {
      position: "absolute !important" as any,
      right: theme.spacing(4),
      top: theme.spacing(3),
      color: `${theme.palette.grey[500]} !important`,
      "@media (max-width: 960px)": {
        right: theme.spacing(3),
        top: theme.spacing(2),
      },
    },
    closeButtonLarge: {
      position: "absolute !important" as any,
      right: theme.spacing(3),
      top: theme.spacing(2),
      color: `${theme.palette.grey[500]} !important`,
      "@media (max-width: 960px)": {
        right: theme.spacing(2),
        top: theme.spacing(1),
      },
    },
  })
);
